var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 0.5,
    stroke: "#022B54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.5H5",
    stroke: "#022B54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18V6.5H7.5V18",
    stroke: "#022B54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooms);
export default __webpack_public_path__ + "static/media/rooms.85817676f94a1b3b345ce8e796bcbb26.svg";
export { ForwardRef as ReactComponent };